import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminLoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin/insights", { replace: true });
  }, [user, navigate]);

  const submit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    const result = await login(email, password);
    if (result.ok) navigate("/admin/insights");
    else setError(result.error);
    setSubmitting(false);
  };

  return (
    <main data-testid="admin-login-page" className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#1C1613] px-5 py-16 text-[#FDFBF7]">
      <img src="/assets/ugi-nautical-map.jpg" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-35 sepia-[0.2]" />
      <div className="absolute inset-0 bg-[#1C1613]/70" />
      <form data-testid="admin-login-form" onSubmit={submit} className="relative w-full max-w-md border border-[#C5A059]/30 bg-[#FDFBF7] p-8 text-[#1C1613] shadow-2xl sm:p-10">
        <img src="/assets/ugi-official-logo-web.png" alt="Unity Gateway International LLP" className="h-16 w-auto object-contain" />
        <p className="mt-10 text-sm font-bold uppercase tracking-[0.28em] text-[#C5A059]">UGI Editorial</p>
        <h1 className="mt-4 font-serif text-4xl font-normal">Authorized access</h1>
        <p className="mt-4 text-sm leading-7 text-[#524842]">Sign in to create and manage UGI Insights articles.</p>
        <div className="mt-8 grid gap-5">
          <label className="grid gap-2 text-xs font-bold uppercase tracking-[0.14em]">Email
            <input data-testid="admin-email-input" type="email" value={email} onChange={(event) => setEmail(event.target.value)} required className="h-12 border border-[#D8D0C3] bg-white px-4 text-sm font-normal tracking-normal focus:outline-none focus:ring-2 focus:ring-[#C5A059]" />
          </label>
          <label className="grid gap-2 text-xs font-bold uppercase tracking-[0.14em]">Password
            <input data-testid="admin-password-input" type="password" value={password} onChange={(event) => setPassword(event.target.value)} required className="h-12 border border-[#D8D0C3] bg-white px-4 text-sm font-normal tracking-normal focus:outline-none focus:ring-2 focus:ring-[#C5A059]" />
          </label>
        </div>
        {error && <p data-testid="admin-login-error" className="mt-5 border border-red-800/20 bg-red-50 px-4 py-3 text-sm text-red-800">{error}</p>}
        <button data-testid="admin-login-submit-button" disabled={submitting} className="mt-8 w-full bg-[#1C1613] px-6 py-4 text-xs font-bold tracking-[0.18em] text-[#FDFBF7] disabled:opacity-60">
          {submitting ? "SIGNING IN..." : "SIGN IN"}
        </button>
      </form>
    </main>
  );
}
